import { useTutorial } from '../../store'

export let hintTimeOut

export function Timer() {
  hintTimeOut = setTimeout(() => {
    useTutorial.setState({ showHint: false })
  }, 5000)
}
